// 3rd
import axios from 'axios';
// utils
import {
    HTTP_SERVICE_UNAVAILABLE,
    HTTP_UNAUTHORIZED,
    HTTP_INTERNAL_SERVER_ERROR,
    HTTP_UNPROCESSABLE_ENTITY,
} from './statuscodes';
import { LOCAL_STORAGE_JWT, LOCAL_STORAGE_ENDPOINT } from './constants';
import env from './env';
import {
    logOutUser,
    showUnavailableScreen,
} from './helper';

export const authHeaders = () => {
    return {
        headers: {
            Authorization: `Bearer ${localStorage.getItem(LOCAL_STORAGE_JWT)}`,
        },
    };
};

export const api = axios.create({
    baseURL: `${env('host')}/api/`,
});

export const guestErrorHandler = (error) => {
    const errorStatus = parseErrorStatus(error);
};

export const errorHandler = (error, cb = () => {
}) => {
    const errorStatus = parseErrorStatus(error);

    // backend offline
    if (!errorStatus) {
        console.warn('no connection to api');
        showUnavailableScreen();
        return;
    }

    // unprocessable entity
    if (errorStatus === HTTP_UNPROCESSABLE_ENTITY) {
        return parseErrors(error);
    }

    // maintenance
    if (errorStatus === HTTP_SERVICE_UNAVAILABLE || errorStatus === HTTP_INTERNAL_SERVER_ERROR) {
        showUnavailableScreen();
        return;
    }

    // not authorized, log off
    if (errorStatus === HTTP_UNAUTHORIZED) {
        console.warn('not authorized');
        logOutUser();
        return;
    }

    // const err = error ? error.response : null;
    //
    // if (!err) return;
    //
    // if (!error.status) {
    //     console.log('no connection');
    // }
    //
    // if (err.status === HTTP_UNAUTHORIZED) {
    //     deleteUserRelatedData();
    //     logOutUser();
    //     redirect(ROUTE_LOGIN);
    // }

    // additional error handler
    cb();
};

export const parseErrorStatus = error => {
    return error.status || error.response && error.response.status;
};

export const parseErrors = error => {
    const response = error.response;
    return response && response.data && response.data.error ? response.data.error : {};
};
